import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTenant } from "./TenantContext";

// Reusable link that can navigate to a route and optionally scroll to a hash section.
// Preserves the current ?borgo=<slug> query string across navigations so multi-tenant
// context is never lost (otherwise the backend would default all endpoints to tadasuni).
export const HashLink = ({ to, hash, children, className, onClick, ...rest }) => {
    const nav = useNavigate();
    const loc = useLocation();
    const { slug } = useTenant();

    // Attach ?borgo=<slug> to the target when the current tenant is not the default one
    // and the caller hasn't already put a query string in `to`.
    const withBorgo = (target) => {
        if (!target || typeof target !== "string") return target;
        if (target.includes("?")) return target;
        if (!slug || slug === "tadasuni") return target;
        return `${target}?borgo=${encodeURIComponent(slug)}`;
    };

    const finalTo = withBorgo(to);

    const handleClick = (e) => {
        e.preventDefault();
        if (onClick) onClick(e);
        const cleanHash = (hash || "").replace(/^#/, "");
        if (to !== loc.pathname) {
            nav(finalTo);
            if (cleanHash) {
                setTimeout(() => {
                    const el = document.getElementById(cleanHash);
                    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                    else window.scrollTo({ top: 0, behavior: "smooth" });
                }, 60);
            } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        } else if (cleanHash) {
            const el = document.getElementById(cleanHash);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <Link to={finalTo} onClick={handleClick} className={className} {...rest}>
            {children}
        </Link>
    );
};
